import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function injectHeadHints() {
  if (typeof document === 'undefined') return;
  const head = document.head;
  const add = (attrs: Record<string, string>) => {
    const link = document.createElement('link');
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    head.appendChild(link);
  };
  // Preconnect a dominios externos críticos
  add({
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com'
  });
  add({
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossorigin: 'anonymous'
  });
  add({
    rel: 'preconnect',
    href: 'https://cdn.shopify.com'
  });
  add({
    rel: 'dns-prefetch',
    href: 'https://connect.facebook.net'
  });
  add({
    rel: 'dns-prefetch',
    href: 'https://www.facebook.com'
  });
  // Preload del hero LCP (Bundle del producto) con Shopify CDN params
  add({
    rel: 'preload',
    as: 'image',
    href: 'https://cdn.shopify.com/s/files/1/0829/1431/2411/files/BUNDLE_PLAN_TIROIDES.png?v=1779798823&width=900&quality=85&format=webp',
    fetchpriority: 'high'
  });
  // theme-color para barra superior móvil
  const themeMeta = document.createElement('meta');
  themeMeta.setAttribute('name', 'theme-color');
  themeMeta.setAttribute('content', '#047857');
  head.appendChild(themeMeta);
})();
render(<App data-id="element-299" />, document.getElementById('root'));